import { Component, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { BsModalService } from 'ngx-bootstrap';
import { CampaignService } from '../../../../common/services/Campaign.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { EmailService } from '../../../../common/services/Email.service';
import { IvrgatewayService } from 'app/common/services/Ivrgateway.service';
import { QueueService } from 'app/common/services/Queue.service';
import { TimeService } from 'app/common/services/Time.service';
import { ExportService } from '../../../../common/services/Export.service';
import { UserService } from '../../../../common/services/User.service';

declare var $: any;
declare var Chartist: any;

@Component({
    selector: "campaign-list",
    templateUrl: "list.template.html",
    styleUrls: ['campaign.css'],
    providers: [BsModalService, CampaignService, EmailService, IvrgatewayService, QueueService, TimeService, UserService]
})



export class ListComponent implements OnInit {
    @Output('backMode') backMode = new EventEmitter();
    public modelFilter: any = {};
    public tab: any = 'call';
    public list: any = [];
    public listToExport: any = [];
    public page_size: number = 10;
    public currentPage: number = 1;
    public exportData: any = [];
    totalItem: any = 0;
    totalPage: any = 0;
    public message: { class: string, content: string } = null;
    public modalRef: any;
    public modalRef2: any;
    public model: any = {};
    public typeModal: any = 'add';
    public campaignTypes = [
        { id: 'all', text: '--Chọn--' },
        // { id: 'sms', text: 'Nhắn tin SMS', templateType: 4 },
        { id: 'call', text: 'Gọi điện' },
        // { id: 'facebook', text: 'Chat Facebook', templateType: 2 },
        { id: 'email', text: 'Gửi email', templateType: 1 },
        // { id: 'zalo', text: 'Chat Zalo', templateType: 3 },
    ];
    public dialModes = [
        { id: '', text: '' },
        // {id: 'preview', text:'Preview'},
        { id: 'progressive', text: 'Progressive' },
        { id: 'Predictive', text: 'Predictive' },
        { id: 'manual', text: 'Manual' },
        { id: 'broadcast', text: 'Broadcast' },
        {id: 'autodial-ivr', text:'Autodial-IVR'}
        // {id: 'autodial-drop', text:'Autodial-Drop'}
    ]
    minDate = new Date();

    public selected: any = {};
    public is_check_all: boolean = false;
    public have_check: boolean = false;
    public allTemplate: any = [];
    public allEmailAccount: any = [];
    public lstTemplate: any = [];
    public allGateway: any = [];
    public allQueue: any = [];
    public allSchedule: any = [];
    public modelCallOut: any = {}
    public checkCount: number = 0;

    constructor(
        private modalService: BsModalService,
        private campaignService: CampaignService,
        private toastr: ToastrService,
        private emailService: EmailService,
        private ivrgatewayService: IvrgatewayService,
        private queueService: QueueService,
        private timeService: TimeService,
        private exportService: ExportService,
        private userService: UserService
    ) {
    }

    ngOnInit() {
        this.modelFilter = {
            from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
            to: moment().format('YYYY-MM-DD HH:mm')
        }
        this.loadData(this.modelFilter);
        this.loadTemplate();
        this.loadEmailAccount();
        this.loadIvrGateway();
        this.loadQueue();
        this.loadSchedule();
    }

    loadTemplate(request: any = {}, sort: any = {}) {
        let templateList = [];
        this.emailService.listTemplate(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.forEach(e => {
                    templateList.push({
                        id: e.id,
                        text: e.template_name,
                        type: e.type
                    });
                });

                this.allTemplate = templateList;
            }
        });
    }

    loadSchedule(request: any = {}, sort: any = {}) {
        let scheduleList = [{
            id: "",
            text: "",
        }];
        request['limit'] = 500;
        request['keyword'] = "";
        this.timeService.listSchedule(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.data.forEach(e => {
                    scheduleList.push({
                        id: e.TIME_SCHEDULE_ID,
                        text: e.TIME_SCHEDULE_NAME
                    });
                });

                this.allSchedule = scheduleList;
            }
        });
    }

    loadEmailAccount(request: any = {}, sort: any = {}) {
        let emailList = [{
            id: "",
            text: "",
        }];
        this.emailService.listAccount(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.forEach(e => {
                    emailList.push({
                        id: e.ID,
                        text: e.ACCOUNT_NAME
                    });
                });

                this.allEmailAccount = emailList;
            }
        });
    }

    loadIvrGateway(request: any = {}, sort: any = {}) {
        let allGateway = [{
            id: "",
            text: "",
        }];
        this.ivrgatewayService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.ivrgateways.forEach(e => {
                    allGateway.push({
                        id: e.ivrgateway_id,
                        text: e.line
                    });
                });
                this.allGateway = allGateway;

            }
        });
    }

    loadQueue(request: any = {}, sort: any = {}) {
        let allQueue = [{
            id: "",
            text: "",
        }];
        this.queueService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                res.data.queues.forEach(e => {
                    allQueue.push({
                        id: e.QUEUE_ID,
                        text: e.DESCRIPTION
                    });
                });
                this.allQueue = allQueue;

            }
        });
    }

    loadData(request: any = {}, sort: any = {}) {
        this.list = [];
        this.listToExport = [];
        // this.selected = {};
        // this.have_check = false;
        // this.is_check_all = false;
        request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }

        this.campaignService.list(request).toPromise().then(res => {
            if (res.status == 200) {
                this.listToExport = res.data.listToExport;
                this.list = res.data.list;
                this.is_check_all = true;
                this.list.forEach(e => {
                    if (!this.selected[e._id]) {
                        this.is_check_all = false;
                    }
                    let type = _.find(this.campaignTypes, { id: e.campaign_type });
                    if (type) {
                        e.campaignType = type.text;
                    } else {
                        e.campaignType = "";
                    }
                    e.time_start = moment(e.time_start).utc(false).format("YYYY-MM-DD HH:mm");
                    e.time_end = moment(e.time_end).utc(false).format("YYYY-MM-DD HH:mm");
                    // e.created_at = moment(e.created_at).utc(false).format("YYYY-MM-DD HH:mm");
                })
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;
            } else {
                this.list = [];
            }

        }, err => {
            this.list = [];
        });
    }

    checkAll() {
        this.is_check_all = !this.is_check_all;
        this.list.forEach(e => {
            this.selected[e._id] = this.is_check_all;
            if (this.selected[e._id]) this.checkCount += 1; else this.checkCount -= 1;
        });
        // this.have_check = this.is_check_all;
    }

    selectOne(contact_id) {
        // var total = this.list.length;
        // var count = 0;
        this.selected[contact_id] = !this.selected[contact_id];
        if (this.selected[contact_id]) this.checkCount += 1; else this.checkCount -= 1;
        // Object.keys(this.selected).forEach(key => {
        //     if(this.selected[key]) {
        //         count++;
        //         this.have_check = true;
        //     }
        // });
        // if(total == count){
        //     this.is_check_all = true;
        // } else {
        //     this.is_check_all = false;
        // }
        // if(count == 0){
        //     this.have_check = false;
        // }
        this.is_check_all = true;
        this.list.forEach(e => {
            if (!this.selected[e._id]) {
                this.is_check_all = false;
            }
        })
    }

    openDetailCampaign(campaign_id) {
        this.backMode.emit({
            mode: 'detail',
            id: campaign_id
        });
    }

    openConfirmDelete(template: TemplateRef<any>, id) {
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if (y) {
            this.submitDelete();
        }
    }

    updateStatus(index, status) {
        if (this.list[index]) {
            this.campaignService.update(this.list[index]._id, { campaign_status: status }).subscribe(res => {
                if (!res.error) {
                    this.list[index].campaign_status = status;
                    this.toastr.success('Chuyển trạng thái chiến dịch thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.error('Cập nhật không thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                }
            })
        }
    }

    submitDelete() {
        let delete_ids = [];
        Object.keys(this.selected).forEach(function (key) {
            if (this.selected[key]) {
                delete_ids.push(key);
            }
        }.bind(this));
        return this.campaignService.deleteMany({ campaign_ids: delete_ids }).subscribe(res => {
            if (!res.error) {
                this.toastr.success('Xóa thành công', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
                setTimeout(function () {
                    this.loadData();
                }.bind(this), 1500);
                // this.modalRef2.hide();
            } else {
                this.toastr.error('Xóa không thành công', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        });
    }

    copy(payload) {
        delete payload._id;
        payload['name'] = payload['name'] + ' copy';
        this.campaignService.create(payload).subscribe(res => {
            if (res) {
                let error = res.error;
                if (error) {
                    this.toastr.error('Sao chép thất bại', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.toastr.success('Sao chép thành công', '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });

                    this.openDetailCampaign(res.data._id);
                }
            }
        }, error => {
            this.message = { class: "alert dark alert-danger", content: error.message };
        });
    }

    changeTab(tab) {
        if (tab != this.tab) {
            this.tab = tab;
            this.modelFilter = {
                from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
                to: moment().format('YYYY-MM-DD HH:mm')
            }
            this.loadData();
        }
    }

    changeDialMode($event) {
        this.model['dial_mode'] = $event.value;
    }

    changeSchedule($event) {
        this.model.schedule_id = $event.value;
    }

    changeCampaignTypeAdd($event) {
        this.model["campaign_type"] = $event.value;
        if ($event.value == "call") {
            this.model["email_account_id"] = undefined;
            this.model["template_id"] = undefined;
        } else {
            this.model["dial_mode"] = undefined;
            this.model["ivrgateway_id"] = undefined;
            this.model["queue_id"] = undefined;
            this.model["callback_url"] = undefined;
            this.lstTemplate = [{
                id: "",
                text: "",
            }];
            let type = _.find(this.campaignTypes, { id: $event.value });
            if (type) {
                this.allTemplate.forEach(e => {
                    if (e.type == type.templateType) {
                        this.lstTemplate.push(e);
                    }
                })
            }
        }
    }

    openModal(template: TemplateRef<any>, id?: any) {
        this.message = null;
        this.model = {};
        this.modelCallOut = {};
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
        // (<any>$('.input-date')).datepicker({ format: 'dd/mm/yyyy' });

        this.typeModal = id ? 'edit' : 'add'

    }

    openModalCallOut(index, template: TemplateRef<any>) {
        this.message = null;
        this.modelCallOut = {
            agent_ids: [],
            max_customer: 0
        };
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
    }

    public changeUser(e: any): void {
        this.modelCallOut['agent_ids'] = e.value;
    }

    submitCallOut() {
        console.log(this.modelCallOut);
    }

    saveCampaign() {
        this.model.time_start = this.model.time_start ? this.model.time_start : $('#time_start').val();
        this.model.time_end = this.model.time_end ? this.model.time_end : $('#time_end').val();
        if (this.model.time_start.toString().includes("Indochina Time")) {
            this.model.time_start = moment(this.model.time_start).utc(true).toISOString();
        } else {
            this.model.time_start = moment(this.model.time_start).utc(false).toISOString();
        }
        if (this.model.time_end.toString().includes("Indochina Time")) {
            this.model.time_end = moment(this.model.time_end).utc(true).toISOString();
        } else {
            this.model.time_end = moment(this.model.time_end).utc(false).toISOString();
        }
        if (!this.model.name || this.model.name.trim() == '') {
            this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" };
        }
        // else if(!this.model.budget || this.model.budget == 0) {
        //     this.message = { class: "alert dark alert-danger", content: "Ngân sách không được bỏ trống !" };
        // } else if(!this.model.budget || this.model.budget < 0) {
        //     this.message = { class: "alert dark alert-danger", content: "Ngân sách không hợp lệ !" };
        // } else if(this.model.budget_on_day && this.model.budget_on_day < 0) {
        //     this.message = { class: "alert dark alert-danger", content: "Ngân sách theo ngày không hợp lệ !" };
        // } 
        else if (!this.model.campaign_type || this.model.campaign_type == "all") {
            this.message = { class: "alert dark alert-danger", content: "Kênh không được bỏ trống !" };
        }
        // else if(this.model.campaign_type == 'call' && !this.model.ivrgateway_id) {
        //     this.message = { class: "alert dark alert-danger", content: "Đầu số gọi ra không được bỏ trống !" };
        // }
        else if (this.model.campaign_type == 'call' && !this.model.queue_id) {
            this.message = { class: "alert dark alert-danger", content: "Queue không được bỏ trống !" };
        } else if (this.model.campaign_type == 'call' && !this.model.dial_mode) {
            this.message = { class: "alert dark alert-danger", content: "Hình thức không được bỏ trống !" };
        } else if (this.model.campaign_type == 'email' && !this.model.email_account_id) {
            this.message = { class: "alert dark alert-danger", content: "Tài khoản email không được bỏ trống !" };
        } else if (this.model.campaign_type == 'email' && !this.model.template_id) {
            this.message = { class: "alert dark alert-danger", content: "Mẫu tin nhắn không được bỏ trống !" };
        } else if (!this.model.schedule_id) {
            this.message = { class: "alert dark alert-danger", content: "Lịch làm việc không được bỏ trống !" };
        } else if (!this.model.time_start) {
            this.message = { class: "alert dark alert-danger", content: "Thời gian bắt đầu không được bỏ trống !" };
        } else if (!this.model.time_end) {
            this.message = { class: "alert dark alert-danger", content: "Thời gian kết thúc không được bỏ trống !" };
        } else if (this.model.time_start && this.model.time_end && this.model.time_end < this.model.time_start) {
            this.message = { class: "alert dark alert-danger", content: "Thời gian kết thúc không được sớm hơn thời gian bắt đầu !" };
        } else {
            this.model.name = this.model.name.trim();
            this.model.callback_url = this.model.callback_url ? this.model.callback_url.trim() : '';
            let payload = _.assign({}, this.model);
            delete payload._id;

            if (this.typeModal == 'edit') {
                let campaign_id = parseInt(this.model._id);
                this.campaignService.update(campaign_id, payload).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                            this.toastr.error('Cập nhật thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                            this.toastr.success('Cập nhật thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                            this.loadData();
                            this.modalRef.hide();
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                });
            } else {
                this.campaignService.create(payload).subscribe(res => {
                    if (res) {
                        let error = res.error;
                        if (error) {
                            this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                            this.toastr.error('Thêm mới thất bại', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });
                        } else {
                            this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                            this.toastr.success('Thêm mới thành công', '', {
                                timeOut: 4000,
                                positionClass: 'toast-bottom-right'
                            });

                            this.modalRef.hide();
                            this.openDetailCampaign(res.data._id);
                        }
                    }
                }, error => {
                    this.message = { class: "alert dark alert-danger", content: error.message };
                });
            }
        }
    }

    changeCampaignType($event) {
        this.modelFilter.type = $event.value;
    }

    changeEmail($event) {
        this.model["email_account_id"] = $event.value;
    }

    changeIvrGateway($event) {
        this.model["ivrgateway_id"] = $event.value;
    }

    changeQueue($event) {
        this.model["queue_id"] = $event.value;
    }

    changeTemplate($event) {
        this.model["template_id"] = $event.value;
    }

    submitFilter() {
        this.currentPage = 1;
        this.totalItem = this.totalPage = 0;
        if (this.modelFilter.name) {
            this.modelFilter.name = this.modelFilter.name.trim();
        }
        let payload = _.assign({}, this.modelFilter);
        if (payload.from) payload.from = moment(payload.from).format('YYYY-MM-DD HH:mm');
        if (payload.to) payload.to = moment(payload.to).format('YYYY-MM-DD HH:mm');
        this.loadData(payload);
    }

    refresh() {
        this.modelFilter = {
            name: '',
            type: 'all',
            from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
            to: moment().format('YYYY-MM-DD HH:mm')
        }
        console.log(this.modelFilter);
        this.loadData(this.modelFilter);
    }
    setPage(page: number) {
        let payload = _.assign({}, this.modelFilter);
        if (payload.from) payload.from = moment(payload.from).format('YYYY-MM-DD HH:mm');
        if (payload.to) payload.to = moment(payload.to).format('YYYY-MM-DD HH:mm');
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadData(payload);
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadData(payload);
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    export() {
        this.exportData = [];
        this.listToExport.forEach(campaign => {

            this.exportData.push({
                'Tên chiến dịch': campaign.name,
                'Trạng thái': campaign.campaign_status,
                'Loại chiến dịch': campaign.campaign_type == 'email' ? 'Gửi email' : 'Gọi điện',
                //   'Ngân sách (đ)' : campaign.budget,
                //   'Ngân sách theo ngày (đ)' : campaign.budget_on_day,
                'Tổng giao dịch': campaign.total_run,
                'Tổng giao dịch thành công': campaign.total_run_success.value,
                'Tổng giao dịch không thành công': campaign.total_run_failed.value,
                'Tổng khách hàng': campaign.total_contact.value,
                'Tổng khách hàng chưa liên hệ được': campaign.total_contact_failed.value,
                'Lịch chạy': moment(campaign.time_start).utc(false).format("YYYY-MM-DD HH:mm") + ' - ' + moment(campaign.time_end).utc(false).format("YYYY-MM-DD HH:mm"),
                'Thời gian tạo': moment(campaign.created_at).format("YYYY-MM-DD HH:mm"),
            });
        })
        this.exportService.exportExcel(this.exportData, 'Báo cáo chiến dịch ' + moment(new Date()).format("YYYY-MM-DD HH-mm"));
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/campaign/list.component.ts